module.exports = __webpack_public_path__ + "static/media/composer.821989de.jpg";